export default "__VITE_ASSET__BNYlkrr7__"